// removed by extract-text-webpack-plugin
module.exports = {"search":"App-search-8c7db186","searchOn":"App-searchOn-feff3b70","displayNone":"App-displayNone-ae07856c","footerContainer":"App-footerContainer-e427d811"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/App.scss
// module id = 914
// module chunks = 0